const Config = {
    genAIEnabled : false,
    matomoURL : 'https://hb-trk.maya.ai/',
    matomoSiteID: 3
};

export default Config
